import React from 'react'

import LoginBg from '../../assets/images/LoginBg.jpg';
import Privacypage1 from '../../assets/images/Privacypage1.jpg';
import { Link } from 'react-router-dom';

const Privacy = () => {

  return (
    <>
      <section className='AllpageheaderSection'>
        <div className='AllpageheaderSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <h6><Link to='/'><i className='fas fa-home'></i> Home</Link> <span className='PageHead'>PRIVACY & POLICY</span></h6>
            </div>
          </div>
        </div>
      </section>
      <section className='AboutusPageSection'>
        <div className='AboutusPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 col-sm-7 col-xs-12'>
              <h2>Privacy & Policy</h2>
              <h3>This website does not automatically capture any specific personal information from you (like name, phone number or e-mail address), that allows us to identify you individually. </h3>
              <p> If you choose to provide us with your personal information, like names or addresses, when you visit our website, we use it only to fulfill your request for information. To use the Interact with Ernet, this website requires user registration. Information so collected is used to facilitate interaction.
                We do not sell or share any personally identifiable information volunteered on this site to any third party (public/private). Any information provided to this website will be protected from loss, misuse, unauthorized access or disclosure, alteration, or destruction.
                We gather certain information about the User, such as Internet protocol (IP) address, domain name, browser type, operating system, the date and time of the visit and the pages visited. We make no attempt to link these addresses with the identity of individuals visiting our site unless an attempt to damage the site has been detected.

              </p>
            </div>

            <div className='col-md-5 col-sm-5 col-xs-12'>
              <div className='Aboutuspageimg'>
                <img src={Privacypage1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Privacy